import { useMantineTheme } from "@mantine/core"
import { IconEye, IconEyeOff } from "@tabler/icons-react"

type IconVisibleProps = {
  isVisible: boolean
}

export const IconVisible = ({ isVisible }: IconVisibleProps) => {
  const theme = useMantineTheme()
  return isVisible ? (
    <IconEye size={theme.other.icon.size} stroke={theme.other.icon.stroke} />
  ) : (
    <IconEyeOff
      color="var(--mantine-color-dimmed)"
      size={theme.other.icon.size}
      stroke={theme.other.icon.stroke}
    />
  )
}
